function getDeviceOS() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // 判断是否为 iOS 设备
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS';
    }
    
    // 判断是否为 Android 设备
    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    // 默认返回未知设备
    return 'Unknown';
}

// 使用示例：
const deviceOS = getDeviceOS();
console.log('deviceOS:'+deviceOS);

const appAndroid = document.getElementsByClassName("app-download-android");
const appIos = document.getElementsByClassName("app-download-ios");

if(deviceOS=='iOS'){
    appAndroid.add("hidden");
}

if(deviceOS=='Android'){
    appIos.add("hidden");
}
